module.exports = __webpack_public_path__ + "static/img/item4.decb88b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_picture/item4.png
// module id = uLqN
// module chunks = 0